import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';

export const TYPES = {
    waermeerzeuger_heizung: 'heatGeneratorHeating',
    energietraeger: 'energySource',
    waermeerzeuger_warmwasser: 'heatGeneratorHotWater',
    bauperiode: 'periodOfConstruction',
    gebaeudekategorie: 'buildingCategory',
    gebaeudeklasse: 'buildingClass',
}

export class EchCode extends BaseModel {
    // properties
    id: number | null = null;
    ech_doc_id: string | null = null;
    ech_variable_name: string | null = null;
    code: number | null = null;
    i18n_key: string | null = null;
    bezeichnung: string | null = null;

    getClassName(): string {
        return 'EchCode';
    }
}

export class EchCodeCollection extends BaseCollection<EchCode> {
    protected modelCls = EchCode;

    public getModelClassName(): string {
        return 'EchCode';
    }
}

const _globalEchCodeCollections: Map<typeof TYPES[keyof typeof TYPES], EchCodeCollection> = new Map();

/**
 * global (single instance) collection: To be used where a global, shared instance can be used.
 * Note that this collection MUST NOT be filered / ordered on other places, as it is a shared instance!
 * @returns
 */
export function globalEchCodeCollection(variableName: typeof TYPES[keyof typeof TYPES]): EchCodeCollection {
    let collection = _globalEchCodeCollections.get(variableName);
    if (!collection) {
        collection = new EchCodeCollection();
        collection.setQueryParams({
            filter: [
                {
                    id: 'ech_variable_name',
                    property: 'ech_variable_name',
                    value: variableName,
                }
            ],
            sort: [
                {
                    property: 'ech_variable_name',
                    direction: 'asc',
                },
                {
                    property: 'code',
                    direction: 'asc',
                },
            ],
        });
        collection.query();
        _globalEchCodeCollections.set(variableName, collection);
    }
    return collection;
}
